const { h, render, Component } = require('preact');

class Gift extends Component {
  constructor() {
    super();
    this.getGiftElement = this.getGiftElement.bind(this);
  }

  getGiftElement(orderStatusInfo){
    if(orderStatusInfo.giftDeliveryMethod=='email')
      return <span>{I18n.translate('js.modules.support.email_gift')} {orderStatusInfo.giftRecipientName}</span>
    else
      return <span>{I18n.translate('js.modules.support.printed_gift')} {orderStatusInfo.giftRecipientName}</span>
  }

  render({order}) {
    if(!order.status.giftInfo)
      return null
    let orderStatusInfo = order.status.giftInfo
      if(orderStatusInfo.isSentGift)
      {
        return (
          <div class="gift-info">
            <p>
              <span class="icon-gift"></span>
              {this.getGiftElement(orderStatusInfo)}
            </p>
          </div>
        )
      }
      else if(orderStatusInfo.isReceivedGift)
      {
        return(
          <div class="gift-info">
          <p>
            <span class="icon-gift"></span>
            {I18n.translate('js.modules.support.gift_from')}{orderStatusInfo.giftFromName}
          </p>
          </div>
        )
      }
      return null
  }
}
module.exports = Gift
